import type { Deal } from '../../../types/Deal';

export default (
  deal: Pick<Deal, 'end_time' | 'start_time'>,
  params: Partial<Record<string, string>>,
  timeType: string,
): number | null => {
  // Allow forcing an end time/start time with the 'end_time' or 'start_time' url param
  // added for easier testing
  // E.g. '2017/10/31 09:50:00'
  // Otherwise use a deal end time/start time (if it exists)
  const paramDealTime = params[timeType];
  if (paramDealTime) {
    return new Date(paramDealTime).getTime() / 1000;
  }
  if (deal[timeType]) {
    return deal[timeType];
  }
  return null;
};
